// extracted by mini-css-extract-plugin
export default {"rightIconColor":"r23Ki2h9NLkdPF1DrKuB"};